import { render, staticRenderFns } from "./AdobePremiereIcon.vue?vue&type=template&id=55987b6e"
import script from "./AdobePremiereIcon.vue?vue&type=script&lang=js"
export * from "./AdobePremiereIcon.vue?vue&type=script&lang=js"
import style0 from "./AdobePremiereIcon.vue?vue&type=style&index=0&id=55987b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports